import { render } from "./ModalListaPropostaComerciais.vue?vue&type=template&id=4c11f246"
import script from "./ModalListaPropostaComerciais.vue?vue&type=script&lang=js"
export * from "./ModalListaPropostaComerciais.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__